/* eslint-disable import/no-named-as-default */
/* eslint-disable import/no-named-as-default-member */
import Dashboard from './pages/Dashboard';
import Policy from './pages/Policy';
import Profile from './pages/Profile';
import ViewProfile from './pages/Profile/ViewProfile';
import Customers from './pages/Customers';
import AddCustomer from './pages/Customers/AddCustomer';
import EditCustomer from './pages/Customers/EditCustomer';
import Collections from './pages/Collections';
import AddCollectionEntry from './pages/Collections/AddCollectionEntry';
import AddCollectionNewEntry from './pages/Collections/AddCollectionNewEntry';
import AddCollectionEntryWithoutValues from './pages/Collections/AddCollectionEntryWithoutValues';
import Payments from './pages/Payments';
import NewPayment from './pages/Payments/NewPayment';
import UpdateCollectionEntry from './pages/Collections/updateCollectionEntry';


const pageList = [
  
  { name: 'My Profile', path: '/app', component: Dashboard, icon: '', },
  { name: 'Policy', path: '/app/policy', component: Policy, icon: '', },
  { name: 'Profile', path: '/app/profile', component: Profile, icon: '', },
  { name: 'View Profile', path: '/app/profile/view', component: ViewProfile, icon: '', },
  { name: 'Customers', path: '/app/customers', component: Customers, icon: '', },
  { name: 'Add Customer', path: '/app/customer/new', component: AddCustomer, icon: '', },
  { name: 'Edit Customer', path: '/app/customer/edit/:id', component: EditCustomer, icon: '', },
  { name: 'Collections', path: '/app/collections', component: Collections, icon: '', },
  { name: 'Collection Entry', path: '/app/collection/new', component: AddCollectionEntryWithoutValues, icon: '', },
  { name: 'Update Collection', path: '/app/collection/edit', component: UpdateCollectionEntry, icon: '', },
  { name: 'Payments', path: '/app/payments', component: Payments, icon: '', },
  { name: 'New Payment', path: '/app/payment/new', component: NewPayment, icon: '', },
 
];

export default pageList;
